import { FaAngular, FaNode, FaReact } from "react-icons/fa";
import { SiTypescript, SiFirebase, SiHtml5, SiMysql, SiAmazonaws, SiMaterialdesign, SiNextdotjs } from "react-icons/si";
import { DiCss3 } from "react-icons/di";
import { IoLogoJavascript } from "react-icons/io";

import igtImg from "../../assets/igt.png";
import indelibal_img from "../../assets/indelibal.png";
import pitchmeo_img from "../../assets/pitchmeo.png";

import project2 from "../../assets/javascript_email_with_googleSheet.png";
import project3 from "../../assets/text_to_speech_converter.png";
import project4 from "../../assets/image_search_engine.png";
import drag_drop_img from '../../assets/drag_drop2.png'
import music_app_img from '../../assets/music_app.png'
import lounch_app_img from '../../assets/website_launching_page3.png'
import Text_to_QR_Code_Generator from '../../assets/text-to-qr-code.png'
import Instagram_story_img from '../../assets/insta_story_feature.png'
import Image_Background_Change_Effect_img from '../../assets/backgroundChangeEffect.png'
import Dark_Mode_Fun_with_Random_Pass_Project_img from '../../assets/randomPassWithDarkModeFun5.png'
import Instagram_love_button_img from '../../assets/instaLoveButton.png'
import Js_Form_Validation_img from '../../assets/jsFormValidation.png'
import Image_Gallery_img from '../../assets/imageGallery.png'
import Custom_Cursor_img from '../../assets/customCurso.png'
import Js_Note_App_img from '../../assets/jsNotesapp.png';
import To_Do_List_App_img from '../../assets/to-do-list.png';
import Quiz_App_img from '../../assets/quizApp.png';
import Weather_App_img from '../../assets/watherApp.png';
import Quote_App_img from '../../assets/qouteApp.png';
import Custom_Toaster_App_img from '../../assets/toaster_img3.png';
import Stopwatch_App_img from '../../assets/stopWatchTimerImg.png';
import Calculator_img from '../../assets/calculetorImg.png';
import Success_pop_up_img from '../../assets/successPopUpImg.png';
import Pass_hide_show_eyes_img from '../../assets/passHideShowEyesImg.png';
import Current_Date_img from '../../assets/currentDateImg.png';
import Custom_Select_Option_img from '../../assets/customSelectMenuImg.png';
import aigImg from '../../assets/agi-moneey-admin.png'
// TODO: drop a screenshot of this portfolio at src/assets/portfolio.png and
// import it here — the placeholder below is only a stand-in.
import portfolio_img from '../../assets/default_image.jpg'
import aigmarketing from '../../assets/agi-moneey-marketing.png'


export const projectsData1 = [

  {
    title: "AGI Moneey- Admin Dashboard",
    description: `A FinTech platform that gives employees instant and secure access to their earned salary.
Designed to reduce financial stress and improve overall financial wellness.`,
    days: 'Worked on as a frontend angular developer',
    img: aigImg,
    alt: "AGI Moneey FinTech dashboard built in Angular and TypeScript by Aman Jaiswal, frontend Angular developer",
    techIcons: [FaAngular, SiTypescript, SiMaterialdesign, SiAmazonaws, IoLogoJavascript, DiCss3, SiHtml5],
    liveLink: "https://devadmin.agimoneey.com/",
    language: ["angular", "client"],
  },

  {
    title: "AGI Moneey- Marketing",
    description: `Apply for a personal loan online with zero collateral. Get instant approval, flexible EMI options, and funds transferred directly to your bank account within hours.`,
    days: 'Worked on as a frontend nextJs developer',
    img: aigmarketing,
    alt: "AGI Moneey Webisite built in Next.js and TypeScript by Aman Jaiswal, frontend Next.js developer",
    techIcons: [SiNextdotjs, IoLogoJavascript, DiCss3, SiHtml5],
    liveLink: "https://agimoneey.com/",
    language: ["nextjs", "client"],
  },

  {
    title: "Aman Jaiswal Portfolio",
    description: `This portfolio — a single-page React application with light/dark theming, scroll animations and a filterable project gallery, built to be fast and fully responsive.`,
    days: 'Built and maintained by me as a React developer',
    img: portfolio_img,
    alt: "Portfolio website of Aman Jaiswal, built in React by Aman Jaiswal, React developer",
    techIcons: [FaReact, IoLogoJavascript, DiCss3, SiHtml5],
    liveLink: "https://iamamanjaiswal.com/",
    codeLink: "https://github.com/AMAN-JAISWALL",
    language: ["react"],
  },

  {
    title: "It’s Game Time",
    description: `A sports social community where fans connect, share updates, and engage with real-time sports content. Offers live scores, news, and discussions for every sport enthusiast.`,
    days: 'Worked on as a frontend angular developer',
    img: igtImg,
    alt: "It's Game Time sports social community built in Angular and TypeScript by Aman Jaiswal, Angular developer",
    techIcons: [FaAngular, SiTypescript, SiFirebase, IoLogoJavascript, DiCss3, SiHtml5],
    liveLink: "https://www.itsgametime.com/",
    language: ["angular", "client"],
  },
  {
    title: "Indelible",
    description: `Indelible is a travel management system for Admins and Operators with booking, rate, commission, and reporting features.`,
    days: 'Worked on as a frontend angular developer',
    img: indelibal_img,
    alt: "Indelible travel management system built in Angular, Node.js and MySQL by Aman Jaiswal, frontend developer",
    techIcons: [FaAngular, FaNode, SiMysql],
    liveLink: "https://indelible.itsabacus.net/auth/signin",
    language: ["angular", "client"]
  },
  {
    title: "Pitchmeo",
    description: `PitchMeo is a video-based job portal where employers post job videos and candidates apply with video introductions, simplifying hiring and interview scheduling.`,
    days: 'Worked on as a backend node.js developer',
    img: pitchmeo_img,
    alt: "Pitchmeo video-based job portal built in Angular and Node.js by Aman Jaiswal, full stack developer",
    techIcons: [FaAngular, FaNode, SiMysql],
    liveLink: "https://pitchmeo.itsac.in/client/",
    language: ["angular", "client"]
  },

  {
    title: "Email Store on GoogleSheet",
    description: `Email subscription form integrated with Google Sheets.`,
    days: 'A project built by me, in 1 days.',
    img: project2,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://fascinating-valkyrie-e9ab7e.netlify.app/",
    codeLink: "https://github.com/AMAN-JAISWALL/Javascript-email-subscription-form-with-google-sheet",
    language: ["javascript"],
  },
  {
    title: "Image Search Engine",
    description: `Image search engine retrieves images based on user keywords.`,
    days: 'A project built by me, in 1 days.',
    img: project4,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://imagesearchengine55713.netlify.app/",
    codeLink: "https://github.com/AMAN-JAISWALL/image-search-engine",
    language: ["javascript"],
  },
  {
    title: "Text to Speech Converter",
    description: `JS text-to-speech project converts written text to spoken words using browser-based tools, improving accessibility and UX.`,
    days: 'A project built by me, in 1 days.',
    img: project3,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://speechconverter09.netlify.app/",
    codeLink: "https://github.com/AMAN-JAISWALL/Javascript-text-to-speech-converter",
    language: ["javascript"],
  },
  {
    title: "Drag & Drop Effect",
    description: `JS Drag & Drop lets users move web elements interactively by clicking, dragging, and dropping them elsewhere on the page.`,
    days: 'A project built by me, in 1 days.',
    img: drag_drop_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://dragdropeffect.netlify.app/",
    codeLink: "https://github.com/AMAN-JAISWALL/Drag-And-Drop-Functionality",
    language: ["javascript"],
  },
  {
    title: "Music App",
    description: `A JavaScript music app exclusively plays music using JavaScript.`,
    days: 'A project built by me, in 1 days.',
    img: music_app_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://music-app9.netlify.app/",
    codeLink: "https://github.com/AMAN-JAISWALL/javascript-music-app",
    language: ["javascript"],
  },

  {
    title: "Website Launching Page",
    description: `Website currently undergoing maintenance. Exciting launch coming soon!`,
    days: "It's a project built by me, in 1 day.",
    img: lounch_app_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://website-launching-page.netlify.app",
    codeLink: "https://github.com/AMAN-JAISWALL/website-launching-page",
    language: ["javascript"],
  },

  {
    title: "Text to QR Code Generator",
    description: `This is a Javascript Text to QR Code Generator: Converts text input into a QR code image for easy sharing and scanning.`,
    days: "It's a project built by me, in 1 day.",
    img: Text_to_QR_Code_Generator,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://text-to-qr-code-generator.netlify.app/",
    codeLink: "https://github.com/AMAN-JAISWALL/Text-To-QR-Code-Generator",
    language: ["javascript"],
  },

  {
    title: "Javascript Instagram Story Feature",
    description: `It's a project enables users to share temporary media on Instagram-style stories. Built with JavaScript for dynamic interactions.`,
    days: "It's a project built by me, in 1 day.",
    img: Instagram_story_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://instagram-story-feature.netlify.app/",
    codeLink: "https://github.com/AMAN-JAISWALL/javascript-insta-story-feature",
    language: ["javascript"],
  },
  {
    title: "Image Background Change Effect",
    description: `Using JavaScript, dynamically change the background of an image on a webpage in response to user interaction or predefined events.`,
    days: "It's a project built by me, in 1 day.",
    img: Image_Background_Change_Effect_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://image-background-change-effect.netlify.app/",
    codeLink: "",
    language: ["javascript"],
  },
  {
    title: "Dark Mode Fun with Random Pass Project",
    description: `A project incorporating dark mode functionality along with a feature generating random passwords.`,
    days: "It's a project built by me, in 1 day.",
    img: Dark_Mode_Fun_with_Random_Pass_Project_img, // left blank as requested
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://dark-mode-fun-with-random-pass.netlify.app",
    codeLink: "https://github.com/AMAN-JAISWALL/dark-mode-fun-with-random-pass",
    language: ["javascript"],
  },
  {
    title: "Instagram's love button",
    description: `A project simulating the functionality of Instagram's "love" button, allowing users to express their appreciation for content with a simple click.`,
    days: "It's a project built by me, in 1 day.",
    img: Instagram_love_button_img, // left blank as per previous style
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://instagram-love-button.netlify.app",
    codeLink: "", // No code link provided in the snippet
    language: ["javascript"],
  },
  {
    title: "Js Form Validation",
    description: `A project implementing JavaScript to validate form inputs, ensuring data integrity and user input accuracy.`,
    days: "It's a project built by me, in 1 day.",
    img: Js_Form_Validation_img, // you can add the img src if needed
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://js-form-validation09.netlify.app/",
    codeLink: "", // No code link provided here
    language: ["javascript"],
  },
  {
    title: "Image Gallery",
    description: `A project using JavaScript to create an interactive image gallery, allowing users to view and navigate through a collection of images with various features such as zoom and slideshow.`,
    days: "It's a project built by me, in 1 day.",
    img: Image_Gallery_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://js-image-gallery09.netlify.app/",
    codeLink: "", // no code link provided
    language: ["javascript"]
  },
  {
    title: "Custom Cursor",
    description: `A project utilizing JavaScript to customize the appearance and behavior of the cursor on a webpage, providing a unique and interactive user experience.`,
    days: "It's a project built by me, in 1 day.",
    img: Custom_Cursor_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://custom-cursor09.netlify.app/",
    codeLink: "", // no code repo link provided
    language: ["javascript"]
  },
  {
    title: "Js Note App",
    description: `A js project to create a web application for taking, storing, and managing notes, offering functionalities like adding, editing, and deleting notes in a user-friendly interface.`,
    days: "It's a project built by me, in 1 day.",
    img: Js_Note_App_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://notes-app09.netlify.app/",
    codeLink: "", // no code repo link provided
    language: ["javascript"]
  },
  {
    title: "To Do List App",
    description: `It's a project for managing tasks, enabling users to add, edit, and remove to-do items with features like marking tasks as completed and organizing them in a list format.`,
    days: "It's a project built by me, in 1 day.",
    img: To_Do_List_App_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://to-do-list-app09.netlify.app/",
    codeLink: "", // no repo link provided
    language: ["javascript"]
  },
  {
    title: "Quiz App",
    description: `A JavaScript-based project that presents users with a series of questions and multiple-choice answers, allowing them to test their knowledge on a particular topic, with features such as scoring, progress tracking, and feedback on correct/incorrect answers.`,
    days: "It's a project built by me, in 1 day.",
    img: Quiz_App_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://quizapp09.netlify.app/",
    codeLink: "", // No repo link provided
    language: ["javascript"]
  },
  {
    title: "Weather App",
    description: `A web application using HTML, CSS, and JavaScript to display current weather conditions based on user input or location detection. Utilizes APIs like OpenWeatherMap for real-time data retrieval and implements features such as temperature display, weather icons, and location-based forecasts.`,
    days: "It's a project built by me, in 1 day.",
    img: Weather_App_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://weather-app369.netlify.app/",
    codeLink: "", // repo link if available
    language: ["javascript"]
  },
  {
    title: "Quote App",
    description: `A JavaScript Quote App developed using HTML, CSS, and JavaScript. Integrated with a quote API for dynamic content, it displays random quotes and allows users to share their favorite quotes on Twitter.`,
    days: "It's a project built by me, in 1 day.",
    img: Quote_App_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://qoute-app369.netlify.app/",
    codeLink: "", // Add your repo link if available
    language: ["javascript"]
  },
  {
    title: "Custom Toaster App",
    description: `This project offers a sleek solution for displaying notifications on websites. With easy customization options, users can create visually appealing toast notifications to convey important updates effectively.`,
    days: "It's a project built by me, in 1 day.",
    img: Custom_Toaster_App_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://js-toaster-app.netlify.app/",
    codeLink: "", // Add your repo link if available
    language: ["javascript"]
  },
  {
    title: "Stopwatch(Timer) App",
    description: `The Stopwatch Timer App is a user-friendly application designed to provide precise time tracking functionality. With its intuitive interface, users can effortlessly start, stop, and reset the timer with just a few taps.`,
    days: "It's a project built by me, in 1 day.",
    img: Stopwatch_App_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://stopwatch-timer-app09.netlify.app/",
    codeLink: "", // Add your repo link if available
    language: ["javascript"]
  },
  {
    title: "Calculator",
    description: `The Calculator App is a user-friendly tool designed to simplify mathematical calculations on-the-go. Users can perform basic arithmetic operations such as addition, subtraction, multiplication, and division with ease.`,
    days: "It's a project built by me, in 1 day.",
    img: Calculator_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://calculator-app09.netlify.app/",
    codeLink: "", // Add your repo link if available
    language: ["javascript"]
  },
  {
    title: "Success pop-up",
    description: `This is a user-friendly application designed to enhance user experience by providing informative and reassuring pop-up notifications. After submitting a form, users receive a prompt message confirming the successful submission of their details.`,
    days: "It's a project built by me, in 1 day.",
    img: Success_pop_up_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://pop-up-app.netlify.app/",
    codeLink: "", // Add your repo link if available
    language: ["javascript"]
  },
  {
    title: "Pass hide & show eyes",
    description: `Hide and show eyes feature offers users a convenient solution for managing their pass with ease and security. This intuitive application features an innovative eye icon functionality that allows users to toggle between hiding and revealing their passwords as they type.`,
    days: "It's a project built by me, in 1 day.",
    img: Pass_hide_show_eyes_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://pass-hide-show-eyes.netlify.app",
    codeLink: "", // Add your repo link if available
    language: ["javascript"]
  },
  {
    title: "Current Date",
    description: `It's a project that provides users with instant access to the current date on their system. With a clean and minimalist design.`,
    days: "It's a project built by me, in 1 day.",
    img: Current_Date_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://jscalendar-app.netlify.app/",
    codeLink: "", // Add your repo link if available
    language: ["javascript"]
  },
  {
    title: "Custom Select-Option",
    description: `The Custom Select Option Menu App provides a modern and user-friendly interface that elevates the browsing experience.`,
    days: "It's a project built by me, in 1 day.",
    img: Custom_Select_Option_img,
    techIcons: [SiHtml5, DiCss3, IoLogoJavascript],
    liveLink: "https://custom-select-option-menu.netlify.app",
    codeLink: "", // Add GitHub repo link here if available
    language: ["javascript"]
  },






];